// File: /frontend/src/pages/user/ShopOffersPage.js

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getMarketplaceProducts } from '../../services/productService';
import { addToWishlist, removeFromWishlist, checkWishlist } from '../../services/wishlistService';
import WishlistButton from '../../components/common/WishlistButton';

const ShopOffersPage = () => {
  const [offerProducts, setOfferProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOfferProducts();
  }, []);

  const fetchOfferProducts = async () => {
    setLoading(true);
    try {
      // Fetch products with discount (MRP > zammerPrice)
      const response = await getMarketplaceProducts({
        page: 1,
        limit: 20,
        discount: true,
        status: 'active'
      });
      
      if (response.success) {
        setOfferProducts(response.data);
      } else {
        toast.error(response.message || 'Failed to fetch offer products');
      }
    } catch (error) {
      console.error('Error fetching offer products:', error);
      toast.error('Something went wrong fetching offers');
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="shop-offers-page pb-16">
      {/* Header */}
      <div className="bg-white p-4 border-b flex items-center">
        <button onClick={() => navigate(-1)} className="mr-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="text-base font-medium">Shop offers</h1>
      </div>

      {/* Products Grid */}
      <div className="p-4">
        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
          </div>
        ) : offerProducts.length > 0 ? (
          <div className="grid grid-cols-2 gap-4">
            {offerProducts.map((product) => (
              <Link 
                key={product._id} 
                to={`/user/product/${product._id}`} 
                className="group"
                onClick={() => console.log('🛒 Navigating to product:', product._id, product.name)}
              >
                <div className="border rounded-lg overflow-hidden bg-white hover:shadow-lg hover:scale-105 transition-all duration-300 cursor-pointer group-hover:border-orange-300 relative">
                  <div className="relative h-48 bg-gray-200">
                    {product.images && product.images[0] ? (
                      <img 
                        src={product.images[0]} 
                        alt={product.name} 
                        className="h-full w-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                      />
                    ) : (
                      <div className="h-full w-full flex items-center justify-center text-gray-400">No image</div>
                    )}
                    <div className="absolute top-2 right-2 z-10">
                      <WishlistButton 
                        productId={product._id} 
                        size="sm"
                        className="shadow-lg"
                      />
                    </div>
                    <div className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                      {Math.round(((product.mrp - product.zammerPrice) / product.mrp) * 100)}% OFF
                    </div>
                  </div>
                  
                  <div className="p-3">
                    <h3 className="font-medium text-sm text-gray-800 group-hover:text-orange-600 transition-colors line-clamp-2">{product.name}</h3>
                    <div className="mt-1 flex items-center justify-between">
                      <div>
                        <span className="text-orange-600 font-medium">₹{product.zammerPrice}</span>
                        <span className="text-gray-500 text-xs line-through ml-1">₹{product.mrp}</span>
                      </div>
                      <span className="text-green-600 text-xs font-semibold">
                        Save ₹{product.mrp - product.zammerPrice}
                      </span>
                    </div>
                  </div>
                  {/* Click indicator */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 bg-gray-50 rounded-lg">
            <p className="text-gray-600">No offers available right now.</p>
          </div>
        )}
      </div>

      {/* Bottom nav provided by UserRouteWrapper */}
    </div>
  );
};

export default ShopOffersPage; 